export const cieploProfil = [
  0.05, 0.04, 0.02, 0.02, 0.02, 0.02, 0.02, 0.03, 0.04, 0.05, 0.05, 0.05, 0.05, 0.05, 0.04, 0.04, 0.04, 0.04, 0.04,
  0.05, 0.05, 0.06, 0.06, 0.07,
];
